var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateDefault"},[_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[0],"length":4,"interval":['3rem',3,3,3,3]}}),_c('BoardFast',{attrs:{"client":_vm.client,"group":[0],"step":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }